import { createAction, props } from '@ngrx/store';

export const LOAD_AGENTLIST = '[Agent List] Load Agent List';
export const LOAD_AGENTLIST_SUCCESS = '[Agent List] Load Agent List Success';
export const LOAD_AGENTLIST_FAILURE = '[Agent List] Load Agent List Failure';

export const loadAgentList = createAction(LOAD_AGENTLIST);

export const loadAgentListSuccess = createAction(
  LOAD_AGENTLIST_SUCCESS,
  props<{ agents: any[] }>()
);

export const loadAgentListFailure = createAction(
  LOAD_AGENTLIST_FAILURE,
  props<{ error: any }>()
);
